import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

import { confirmEmailChange } from "../../../services/user";
import ROUTES from "../../../constants/routes";

import Logo from "../../../assets/images/Skydive_logo_beta.svg";
import CheckMark from "../../../assets/images/check-mark.svg";

// Step 2 of "Change your email" (see ChangeEmail.tsx / backend's
// UserService.confirmEmailChange for the full flow) - the page the
// confirmation link in the new inbox actually points at. Unlike
// ResetPassword.tsx this needs no form: the token alone is enough to
// apply the change, so this just reads it from the URL and calls the API
// once on mount.
const ConfirmEmailChange = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState<"pending" | "success" | "error">(
    "pending"
  );
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    const confirm = async () => {
      const url = new URL(window.location.href);
      const token = url.searchParams.get("token");

      if (!token) {
        setStatus("error");
        setErrorMessage("This link is missing its confirmation token.");
        return;
      }

      const result: any = await confirmEmailChange(token);
      if (result && result.data) {
        setStatus("success");
      } else {
        setStatus("error");
        setErrorMessage(
          result?.error?.message ||
            "This link has expired or already been used."
        );
      }
    };

    confirm();
  }, []);

  return (
    <div className="userauth-main">
      <div className="container-fluid">
        <img src={Logo} alt="logo" className="logo" />
        <div className="userauth-form text-center">
          {status === "pending" && <h4>Confirming your new email...</h4>}

          {status === "success" && (
            <>
              <img src={CheckMark} alt="success" className="successful-icon" />
              <h4>Your email address has been updated</h4>
              <p className="font12">
                You can now log in with your new email address.
              </p>
              <button
                type="button"
                className="theme-btn success-btn text-uppercase fontBold mt-3"
                onClick={() => navigate(ROUTES.LOGIN)}
              >
                Go to Login
              </button>
            </>
          )}

          {status === "error" && (
            <>
              <h4>We couldn't confirm that link</h4>
              <p className="font12">{errorMessage}</p>
              <button
                type="button"
                className="theme-btn white-btn text-uppercase fontBold mt-3"
                onClick={() => navigate(ROUTES.LOGIN)}
              >
                Go to Login
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmailChange;
